import { ICharacterSmart } from '@avid/common';

import { accumulateNumbersArray } from './array';
import { valuesOfObject } from './object';

export const getUsedSmartPoints = (characterSmart: ICharacterSmart) =>
  accumulateNumbersArray(valuesOfObject(characterSmart));
